import React, { useCallback } from 'react'
import { P2Accordion, P2TextDescription, P2TextInput } from 'react-bootstrap-common-script'
import { StageBPersonalDetail } from '../../../models/classes/stage-b/review-endorse.class'
import { numberPattern } from '../../../utils/shared-pattern';
import { Owner } from '../../../models/polymer/Owner.model';
import { MyInfo } from '../../../models/polymer/MyInfo.model';
import { useAppSelector } from '../../../redux/hook';
import Dropdown from '../../../components/dropdown/dropdown';
import { maritalStatusDropdownItems } from '../../../utils/shared-dropdown';

interface ContactDetailsProps {
  personal_values: StageBPersonalDetail;
  isLoginOutgoing: boolean;
  setFormValue: React.Dispatch<React.SetStateAction<StageBPersonalDetail>>;
  errors: any;
  forceError?: boolean;
}

function ContactDetails({ personal_values, isLoginOutgoing, setFormValue, errors, forceError }: ContactDetailsProps) {
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  
  const handleValueChange = useCallback((key: string) => (value: string | boolean) => {
    setFormValue({...personal_values, login_user: new Owner({...personal_values.login_user, myinfo: new MyInfo({...personal_values.login_user.myinfo, [key.toString()]: value})})})
  },[personal_values, setFormValue])

  return (
    <div className='mt-2 px-4 pt-4 pb-4'>
      <P2Accordion
        defaultOpen={true}
        title={
          <P2TextDescription size='18px' color="#333333" title={"Declared and authorised by:"} />
        }
      >
        <div className='mt-3 d-flex flex-column gap-3'>
        <div className="polymer-summary-contact-details"><P2TextInput disabled={true} required value={personal_values.login_user.myinfo.name ? personal_values.login_user.myinfo.name : loginUser.name} name='name' label='Name' placeholder='Please enter full name' type='text' /></div>
          {isLoginOutgoing && <Dropdown forceError={forceError} required selectedDropdown={personal_values.login_user.myinfo?.marital_status} placeholder="Please indicate marital status" label="Marital status" items={maritalStatusDropdownItems} setSelectedDropdown={handleValueChange("marital_status")}/>}
          <P2TextInput forceError={forceError} isError={!errors?.login_user?.mobile_no?.isValid} errorMsg={errors?.login_user?.mobile_no?.message} maxLength={8} pattern={numberPattern} required value={personal_values.login_user.myinfo?.mobile_no} name='contact_no' label='Contact number' placeholder='Please enter contact number.' type='text' onChange={handleValueChange("mobile_no")} />
          <P2TextInput forceError={forceError} isError={!errors?.login_user?.email?.isValid} errorMsg={errors?.login_user?.email?.message}  maxLength={255} required value={personal_values.login_user.myinfo?.email} name='email' label='Email address' placeholder='Please enter email address' type='text' onChange={handleValueChange("email")} />
          
        </div>
      </P2Accordion>
    </div>
  )
}

export default ContactDetails
